/* eslint-disable no-magic-numbers */

export enum BUDGET_ONBOARDING_STEP {
  START_MONTH = '1',
  SELECT_TYPE = '2',
  LYA_TOGGLE_OFF = '3',
  LYA_CUSTOMISE = '4',
  LYA_ADDITIONAL_CONTROLS = '5',
  LYA_READY_TO_GO = '6',
  AUTO_PREDICTIONS_ACTIVITY = '3',
  AUTO_PREDICTIONS_EXPLAINED = '4',
  AUTO_PREDICTIONS_CUSTOMISE = '5',
  AUTO_PREDICTIONS_ADDITIONAL_CONTROLS = '6',
  AUTO_PREDICTIONS_READY_TO_GO = '7',
  SCRATCH_CUSTOMISE = '3',
  SCRATCH_ADDITIONAL_CONTROLS = '4',
  SCRATCH_READY_TO_GO = '5'
}

export enum SCENARIO_ONBOARDING_STEP {
  CASH_FLOW_IMPORTANT = '1',
  SELECT_TYPE = '2',
  SCRATCH_HISTORICAL = '3',
  SCRATCH_CONTROL_WHAT_YOU_SEE = '4',
  SCRATCH_CUSTOMISE = '5',
  SCRATCH_CONTROL_CASH_FLOW = '6',
  SCRATCH_ADDITIONAL_CONTROLS = '7',
  SCRATCH_READY_TO_GO = '8',
  AUTO_PREDICTIONS_ACTIVITY = '3',
  AUTO_PREDICTIONS_EXPLAINED = '4',
  AUTO_PREDICTIONS_HISTORICAL = '5',
  AUTO_PREDICTIONS_WHAT_YOU_SEE = '6',
  AUTO_PREDICTIONS_CUSTOMISE = '7',
  AUTO_PREDICTIONS_CONTROL_CASH_FLOW = '8',
  AUTO_PREDICTIONS_ADDITIONAL_CONTROLS = '9',
  AUTO_PREDICTIONS_READY_TO_GO = '10',
  LYA_TOGGLE_OFF = '3',
  LYA_HISTORICAL = '4',
  LYA_CONTROL_WHAT_YOU_SEE = '5',
  LYA_CUSTOMISE = '6',
  LYA_CONTROL_CASH_FLOW = '7',
  LYA_ADDITIONAL_CONTROLS = '8',
  LYA_READY_TO_GO = '9'
}

export enum SCENARIO_WITH_INVOICES_ONBOARDING_STEP {
  CASH_FLOW_IMPORTANT = '1',
  INVOICES_BILLS_INCLUDED = '2',
  SELECT_TYPE = '4',
  SCRATCH_HISTORICAL = '5',
  SCRATCH_CONTROL_WHAT_YOU_SEE = '6',
  SCRATCH_CUSTOMISE = '7',
  SCRATCH_CONTROL_CASH_FLOW = '8',
  SCRATCH_ADDITIONAL_CONTROLS = '9',
  SCRATCH_READY_TO_GO = '10',
  AUTO_PREDICTIONS_ACTIVITY = '5',
  AUTO_PREDICTIONS_EXPLAINED = '6',
  AUTO_PREDICTIONS_HISTORICAL = '7',
  AUTO_PREDICTIONS_WHAT_YOU_SEE = '8',
  AUTO_PREDICTIONS_CUSTOMISE = '9',
  AUTO_PREDICTIONS_CONTROL_CASH_FLOW = '10',
  AUTO_PREDICTIONS_ADDITIONAL_CONTROLS = '11',
  AUTO_PREDICTIONS_READY_TO_GO = '12',
  LYA_TOGGLE_OFF = '5',
  LYA_HISTORICAL = '6',
  LYA_CONTROL_WHAT_YOU_SEE = '7',
  LYA_CUSTOMISE = '8',
  LYA_CONTROL_CASH_FLOW = '9',
  LYA_ADDITIONAL_CONTROLS = '10',
  LYA_READY_TO_GO = '11'
}

export enum ONBOARDING_FORECAST_TYPE {
  BUDGET = 'budget',
  SCENARIO = 'scenario',
  SCENARIO_WITH_INVOICES = 'scenario-with-invoices'
}

export const LS_FORECASTING_ONBOARDING_STEP = 'forecasting-onboarding-step';
export const LS_FORECASTING_ONBOARDING_TYPE = 'forecasting-onboarding-type';
export const LS_LIVE_FORECAST_ID = 'live-forecast-id'
